<template>
  <div
    class="blog"
  >
    <image-simple
      variant="is-dark"
      :image-id="article.imageUrl"
      :mobile-image-id="article.imageUrl"
    />
    <div>
      <blog-header>
        <template slot="date">
          {{ article.date }}
        </template>
        <template slot="author">
          {{ article.authorName }}
        </template>
        <template slot="tags">
          {{ article.tags }}
        </template>
        <template slot="social">
          <social-share-bar
            :article="article"
            variant="mobile"
          />
        </template>
      </blog-header>
      <!-- Title -->
      <title-view variant="primary">
        {{ article.title }}
      </title-view>

      <div class="has-max-width">
        <div class="blog__content">
          <!-- Subtitle -->
          <title-view variant="subtitle">
            <span>{{ article.smallTitle }}</span>
          </title-view>

          <!-- Content -->
          <text-view>
            <div v-html="article.text" />
            <br>
          </text-view>
        </div>
      </div>

      <div class="social-footer">
        <social-share-bar
          :article="article"
        />
      </div>
    </div>

    <!-- Footer -->
    <footer-follow-view />
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import variant from '@/mixins/variant';

import ENVIRONMENT from '@/env';

export default {
  name: 'BlogItem',

  components: {
    BlogHeader: () => import('@/components/blog/blog-detail-header'),
    SocialShareBar: () => import('@/components/share/social-share-bar'),
    ImageSimple: () => import('@/components/image/image-simple'),
    TextView: () => import('@/components/text/text-view'),
    TitleView: () => import('@/components/title/title-view'),
    FooterFollowView: () => import('@/components/footer/footer-follow-view')
  },

  mixins: [variant],

  computed: {
    ...mapState('articles', {
      article: (state) => state.article
    }),

    baseUrl() {
      return ENVIRONMENT.baseUrl;
    },

    shareUrl() {
      return `${this.baseUrl}/blog/${this.article.slug}`;
    }
  },

  mounted() {
    const { id } = this.$route.params;
    this.getArticleById(id);
  },

  methods: {
    ...mapActions('articles', [
      'getArticleById'
    ])
  },

  metaInfo() {
    return {
      title: 'Bliss Applications: User-centered design company',
      meta: [
        {
          name: 'description',
          content: this.article.title
        },
        {
          property: 'og:url',
          content: this.shareUrl
        },
        {
          property: 'og:title',
          content: this.article.title
        },
        {
          property: 'og:description',
          content: this.article.smallTitle
        },
        {
          property: 'og:image',
          content: this.article.imageUrl
        },
        {
          name: 'twitter:title',
          content: this.article.title
        },
        {
          name: 'twitter:description',
          content: this.article.smallTitle
        },
        {
          name: 'twitter:image',
          content: this.article.imageUrl
        }
      ]
    };
  }
};
</script>
<style lang="scss" src="@/assets/components/blog/blog-article-detail.scss"></style>



// WEBPACK FOOTER //
// detail.vue